import styled from "@emotion/styled";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

const ActionButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  textTransform: "uppercase",
}));
const LineContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  marginBottom: theme.spacing(1),
}));
function PolicyTypeBanner({
  bannerText,
  handleCancel,
  handleDraft,
  handleReview,
  editable,
}) {
  return (
    <LineContainer>
      {bannerText && (
        <Typography variant="body1" sx={{ width: "100%", textAlign: "left" }}>
          <Box component="span" fontWeight="fontWeightBold">
            {" "}
            {bannerText}
          </Box>
        </Typography>
      )}
      <Box sx={{ width: "100%", textAlign: "right" }}>
        <ActionButton variant="outlined" color="inherit" onClick={handleCancel}>
          Cancel
        </ActionButton>
        {editable && (
          <>
            <ActionButton
              variant="outlined"
              color="inherit"
              onClick={handleDraft}
            >
              Save as Draft
            </ActionButton>
            <ActionButton
              variant="contained"
              color="primaryButton"
              onClick={handleReview}
              disableElevation
            >
              Submit for Review
            </ActionButton>
          </>
        )}
      </Box>
    </LineContainer>
  );
}

export default PolicyTypeBanner;
